import { render, staticRenderFns } from "./OrderInput.vue?vue&type=template&id=bd1a0d8a&scoped=true&"
import script from "./OrderInput.vue?vue&type=script&lang=ts&"
export * from "./OrderInput.vue?vue&type=script&lang=ts&"
import style0 from "./OrderInput.vue?vue&type=style&index=0&id=bd1a0d8a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1a0d8a",
  null
  
)

export default component.exports